import React from 'react';

import { TFunction } from '@lyearn/i18n';
import { cn } from '@lyearn/style';
import { Stack, Typography } from '@lyearn/ui';
import { getAdaptedMarkup } from '@/components/MessageItem/MessageBody/utils';

import { ChatbotMessageType } from '../../types';
import { anchorNone, inlineP, markupContainerStyles, mentionHelperStyles } from './styles';

function UserMessage({ textContent, t }: ChatbotMessageType & { t: TFunction }) {
  return (
    <Stack
      className={cn(
        anchorNone,
        'bg-bg-purple-light rounded-8 self-end py-[1.3rem] px-[1.6rem] justify-self-end ml-[3.6rem]',
      )}
      direction="col">
      <Typography color="text-text-primary" variant="body-long-02">
        <span
          dangerouslySetInnerHTML={getAdaptedMarkup(t, textContent, null)}
          className={cn('markup-container', markupContainerStyles, mentionHelperStyles, inlineP)}
        />
      </Typography>
    </Stack>
  );
}

export default UserMessage;
